import React from "react";

const ScenarioOptions = ({ options, selectedOptionId, onSelect }) => {
  return (
    <div className="scenario-options-wrapper">
      <div className="scenario-options">
        {options.map((opt) => (
          <button
            key={opt.option_id}
            className={`option-button ${
              selectedOptionId === opt.option_id ? "option-selected" : ""
            }`}
            onClick={() => onSelect(opt.option_id)}
          >
            {opt.option_text}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ScenarioOptions;
